import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : "6em 0em")};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10% 0;

  @media (max-width: 1400px) {
    align-items: center;
    padding: 10% 0;
  }
  @media (max-width: 900px) {
    padding: 10% 0;
    align-items: center;
    padding: 0;
  }
  @media (max-width: 700px) {
    padding: 10% 0;
    padding: 2em 0;
  }
`;

export const FormContainer = styled.div`
  width: ${(props) => (props.width ? props.width : "60%")};
  height: 100%;
  display: grid;
  grid-template-columns: ${(props) => (props.grid ? props.grid : "55% 45%")};
  justify-content: center;
  align-items: center;
  border: 1px solid orangered;
  border-radius: 0.25em;

  @media (max-width: 1400px) {
    width: 80%;
  }

  @media (max-width: 900px) {
    width: 90%;
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    grid-template-rows: 50% 50%;
    width: 96%;

    .form {
      /* grid-row: 2 /3; */
      order: 2;
    }
    .container {
      /* grid-row: 1 /2; */
      order: 1;
    }
  }
`;

export const Form = styled.div`
  width: 100%;
  height: 100%;
  padding: 2em 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .select {
    padding: 1em;
    outline: none;
    width: 100%;
    border: 0.5px solid orangered;
    border-radius: 0.25em;
  }
`;

export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1em 0;
`;

export const Label = styled.label`
  align-self: flex-start;
  font-size: 0.9em;
  padding-bottom: 0.4em;
  color: orangered;

  &.error {
    color: red;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 1.2em 0em;
  outline: none;
  border: 0.5px solid orangered;
  border-radius: 0.25em;
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  &.error {
    border: 1px solid red;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transition: all 0.5s ease-in-out;
  }
  &.success {
    border: 0.5px solid orangered;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transition: all 0.5s ease-in-out;
  }

  &:focus::placeholder {
    transform: translate(0%, -120%);
    transition: all 0.5s ease-in-out;
  }
`;

export const H2 = styled.h2`
  text-align: center;
  font-size: 2.5em;
  color: orangered;
`;

export const Button = styled.button`
  display: block;
  background: orangered;
  font-size: 1.1em;
  color: #ffffff;
  padding: 1em 1.5em;
  outline: none;
  border: 0.5px solid orangered;
  border-radius: 0.25em;
  margin: 0.9em 0;
  cursor: pointer;
`;

export const ProgressBtn = styled.div`
  display: flex;
  justify-content: space-between;
  /* padding: 1em; */
`;